export default __webpack_public_path__ + "static/media/store.80c13912.jpg";